(() => {
  return;

  /* eslint-disable no-unreachable */
  document.addEventListener('click keydown', (e) => {
    if (!window.swinger.user.isLoggedIn()) {
      return;
    }

    if (e.type === 'keydown' && e.key !== ' ') {
      return;
    }

    window.swinger.$('[data-notify-me]').forEach((elem) => { elem.removeAttribute('data-invoker'); });

    const elem = window.swinger.eventHub.getTarget(e).closest('[data-notify-me]');

    if (!elem) {
      return;
    }

    window.swinger.$('[data-notify-me]').forEach((elem) => { elem.removeAttribute('data-invoker'); });
    elem.setAttribute('data-invoker', '');

    const itemNumberElem = elem.closest('[data-itemnumber]');
    const itemNumber = itemNumberElem.getAttribute('data-itemnumber');

    window.swinger.overlayManager.create({
      type: 'notify-me-overlay',
      initialState: {
        itemNumber,
      },
      transitionSource: elem,
    });

    e.preventDefault();
    e.stopImmediatePropagation();
  });

  window.swinger.observer.initialize('[data-notify-me]', (elem) => {
    elem.setAttribute('role', 'button');
    elem.setAttribute('aria-controls', 'swinger-overlay-notify-me-overlay');
    elem.setAttribute('aria-expanded', 'false');
    elem.setAttribute('aria-haspopup', 'dialog');
  }, false);
})();
